import { render, staticRenderFns } from "./EmployeeDropdown.vue?vue&type=template&id=5a846ba6"
import script from "./EmployeeDropdown.vue?vue&type=script&lang=js"
export * from "./EmployeeDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports